import React, { useState, useEffect } from 'react';
import { get, post, api, getBranchOwner } from "@config"
import { notification } from 'antd'
import { CardList, CardListItem, CardListItemHeader, DesktopOnly, MobileOnly } from '../../emit/components/styles';

export default function NatureOperationList() {
    const [operations, setOperations] = useState([]);
    const [loading, setLoading] = useState(false);

    const getOperations = () => {
        setLoading(true);
        const branch = getBranchOwner();
        const url = `${api.nfse.config}get-nat-op/?branch_owner=${branch.id}`;
        
        get(url, (data) => {
            setOperations(data || []);
            setLoading(false);
        }, () => setLoading(false));
    };

    const loadOperations = () => {
        setLoading(true);
        const branch = getBranchOwner();
        const url = `${api.nfse.config}load-nat-op/?branch_owner=${branch.id}`;
        
        post(url, {}, () => {
            notification.open({
                message: 'Naturezas de operação sincronizadas!',
                type: 'success',
                duration: 2
            });
            getOperations();
        }, (error) => {
            let desc = 'Ocorreu um erro desconhecido na comunicação.';
            if (error && error.response) {
                try {
                    let resp = JSON.parse(error.response);
                    let errorData = resp.error || resp;
                    desc = errorData.description || errorData.message || (typeof errorData === 'string' ? errorData : desc);
                } catch (e) { }
            } else if (error && error.description) {
                desc = error.description;
            } else if (error && error.message) {
                desc = error.message;
            } else if (typeof error === 'string') {
                desc = error;
            }
            
            notification.open({
                message: 'Erro ao sincronizar naturezas de operação',
                description: desc,
                type: 'error',
                duration: 6
            });
            setLoading(false);
        });
    };

    useEffect(() => {
        getOperations();
    }, []);

    return (
        <div style={{ marginTop: '40px', borderTop: '1px solid #EAECF0', paddingTop: '32px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <div>
                    <h3 style={{ margin: 0, fontWeight: 700, fontSize: '1.25rem', color: '#101828' }}>
                        <i className="fas fa-map-signs me-2" style={{ color: '#0088cc' }}></i> Naturezas da Operação
                    </h3>
                    <p style={{ color: '#667085', fontSize: '0.9rem', margin: 0 }}>Importe as naturezas permitidas pela sua prefeitura para emissão de nota.</p>
                </div>
                <button
                    className="btn btn-outline-info btn-sm"
                    onClick={loadOperations}
                    disabled={loading}
                    style={{ borderRadius: '8px', padding: '8px 16px', fontWeight: 600, borderColor: '#0088cc', color: '#0088cc' }}
                >
                    <i className={`fas ${loading ? 'fa-circle-notch fa-spin' : 'fa-download'} me-2`}></i>
                    {loading ? 'Importando...' : 'Importar da Prefeitura'}
                </button>
            </div>

            <DesktopOnly>
                <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #EAECF0', overflow: 'hidden' }}>
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead style={{ background: '#F9FAFB' }}>
                                <tr>
                                    <th style={{ padding: '12px 20px', fontSize: '0.75rem', fontWeight: 600, color: '#475467', textTransform: 'uppercase', borderBottom: '1px solid #EAECF0' }}>Código InvoiCy</th>
                                    <th style={{ padding: '12px 20px', fontSize: '0.75rem', fontWeight: 600, color: '#475467', textTransform: 'uppercase', borderBottom: '1px solid #EAECF0' }}>Descrição</th>
                                </tr>
                            </thead>
                            <tbody>
                                {operations.map((op, index) => (
                                    <tr key={index}>
                                        <td style={{ padding: '12px 20px', verticalAlign: 'middle' }}>
                                            <span style={{ background: '#F2F4F7', color: '#344054', padding: '4px 8px', borderRadius: '6px', fontSize: '0.85rem', fontWeight: 600 }}>
                                                {op.code}
                                            </span>
                                        </td>
                                        <td style={{ padding: '12px 20px', verticalAlign: 'middle', color: '#475467', fontWeight: 500 }}>
                                            {op.description}
                                        </td>
                                    </tr>
                                ))}
                                {operations.length === 0 && !loading && (
                                    <tr>
                                        <td colSpan="2" style={{ padding: '40px', textAlign: 'center', color: '#667085' }}>
                                            <i className="fas fa-info-circle d-block mb-2" style={{ fontSize: '1.5rem', opacity: 0.5 }}></i>
                                            Nenhuma natureza de operação encontrada. Clique em importar.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </DesktopOnly>
            <MobileOnly>
                {operations.length === 0 && !loading ? (
                    <CardList>
                        <CardListItem>
                            <CardListItemHeader>
                                <div>
                                    <strong style={{ color: '#101828' }}>Nenhuma natureza cadastrada</strong>
                                    <span style={{ color: '#667085', fontSize: '0.9rem' }}>Sincronize para trazer as naturezas disponíveis.</span>
                                </div>
                            </CardListItemHeader>
                        </CardListItem>
                    </CardList>
                ) : (
                    <CardList>
                        {operations.map((op, index) => (
                            <CardListItem key={index}>
                                <CardListItemHeader>
                                    <div>
                                        <span style={{ fontSize: '0.8rem', color: '#667085', textTransform: 'uppercase', fontWeight: 600 }}>Código</span>
                                        <strong style={{ color: '#101828' }}>{op.code}</strong>
                                    </div>
                                </CardListItemHeader>
                                <p style={{ margin: 0, color: '#475467' }}>{op.description}</p>
                            </CardListItem>
                        ))}
                    </CardList>
                )}
            </MobileOnly>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/config/components/NatureOperationList.jsx